export class Style {

  constructor(public id: number, public name: string, public updated_at: string, public created_at: string) {

  }
}


// WEBPACK FOOTER //
// ./src/app/services/style.ts